import { render, staticRenderFns } from "./EditDefaultMonitor.vue?vue&type=template&id=cf6270d2&"
import script from "./EditDefaultMonitor.vue?vue&type=script&lang=js&"
export * from "./EditDefaultMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports